export default function(value) {
	if (value) {
		value = value
			.toString()
			.replace(/\./g, '')
			.replace(/,/g, '.');

		value = Number(value);

		if (!isNaN(value)) {
			return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
		}
	}
}